export enum EntitlementLevel {
  use = 'use',
  useRead = 'use-read',
  useReadGrant = 'use-read-grant',
  read = 'read',
  readGrant = 'read-grant',
  grant = 'grant',
  anyRead = 'anyRead',
  anyUse = 'anyUse',
  anyGrant = 'anyGrant',
  any = 'any',
}
export interface EnvUrls {
  dev?: Urls;
  qa?: Urls;
  prod?: Urls;
}


export interface AuthTimeoutResponse {
  expiresInMilliSeconds: number;
  sessionExists: string;
  expirationTime: string;
}

export interface Urls {
  login?: string;
  logout?: string;
  sessionTime?: string;
  userInfo?: string;
}
